import useProfile from "../../hooks/useProfile.hook";

export default function UserAlias() {
  const { data: profile } = useProfile();

  if (!profile) return null;

  return (
    <div className="bg-her-paradisePink text-white rounded-full w-6 h-6 flex justify-center items-center" title={profile.email}>
      {getAlias(profile.email)}
    </div>
  );
}

function getAlias(email: string) {
  if (!email) return null;

  if (email.length === 0) return null;

  return email[0].toUpperCase();
}
